/* istanbul ignore file */

/**
 * Tests Id's used with the CustomHeader component
 */
export const CUSTOM_HEADER_TEST_ID = "top-navigation-bar";

/**
 * Tests Id's used with the AuthLoading component
 */
export const AUTH_ERROR_TEST_ID: string = "auth-error";
export const AUTH_LOADING_TEST_ID: string = "auth-loading";

/**
 * Tests Id's used within the LocalITHardwareRestockContent
 */
export const NON_STANDARD_ORDER_BUTTON_TEST_ID: string = "non-standard-order-button";
export const STANDARD_ORDER_BUTTON_TEST_ID: string = "standard-order-button";
export const HARDWARE_RESTOCK_CARDS_HEADER_TEST_ID: string = "hardware-restock-cards-header";
export const HARDWARE_RESTOCK_SEARCH_BAR = "hardware-restock-search-bar";

/**
 * Tests Id's used with the CardTable component
 */
export const CARD_TABLE_TEST_ID: string = "card-table";
export const CARD_HEADER_INPUT_TEST_ID: string = "card-header-input";

/**
 * Tests Id's used for the Cards definitions
 */
export const CARD_TAXONOMY_TEST_ID: string = "card-taxonomy";

export const CARD_SKU_TEST_ID: string = "card-sku";

export const CARD_NAME_TEST_ID: string = "card-name";

export const CARD_SPECIFICATION_TEST_ID: string = "card-specification";

export const SUBMIT_ORDER_TEST_ID: string = "submit-hardware-order";

export const REMOVE_STANDARD_ITEM_TEST_ID: string = "remove-standard-item";

export const ORDER_INFORMATION_TEST_IDS = {
    ON_BEHALF: "order-on-behalf",
    COST_CENTER: "order-cost-center",
    COMPANY_GL_CODE: "order-company-gl-code",
    LOCATION_GL_CODE: "order-location-gl-code",
    FINANCE_CODE: "order-finance-code",
    PROJECT_CODE: "order-project-code",
    EXPEDITE: "order-expedite",
    EXPEDITE_DATE: "order-expedite-date",
    DELIVER_TO: "order-deliver-to",
    BUSINESS_JUSTIFICATION: "order-business-justification",
    WATCHERS: "order-watchers",
    ATTACHMENT: "order-attachment",
};

/**
 * Function to create the custom test id for the expand button of a
 * CustomCheckbox component
 *
 * @param {string | undefined} taxonomyId - The taxonomy id to use for the test id
 *
 * @returns {string} The expand button test id
 */
export const generateExpandButtonTestId = (taxonomyId: string | undefined): string => {
    return `expand-button-${taxonomyId}`;
};

/**
 * Collection of test identifiers for Local IT order list components
 *
 * @property {string} SEARCH_FOR - Test ID for search orders input field
 * @property {string} REQUESTER - Test ID for requester field
 * @property {string} STATUS_FILTERS - Test ID for order status filters
 * @property {string} LOCATION_FILTERS - Test ID for location filters
 */
export const LOCAL_IT_ORDER_LIST = {
    NEW_ORDER: "new-order-button",
    SEARCH_FOR: "search-for-orders",
    REQUESTER: "requester",
    STATUS_FILTERS: "order-status-filters",
    LOCATION_FILTERS: "location-filters",
    ORDERS_TABLE: "orders-table",
    PAGINATION: "orders-pagination",
    PREFERENCES: "orders-preference",
};

export const FLASH_BAR_TEST_ID = "flashBarTestId";

export const NON_STANDARD_ORDER = {
    ADD_ITEM: "add-non-standard-item",
    REMOVE_ITEM: "remove-non-standard-item",
};

export const CONFIRM_MODAL = {
    ACCEPT: "confirmation-modal-accept",
    CANCEL: "confirmation-modal-cancel",
};

export const CUSTOM_MODAL = {
    OPEN_MODAL_BUTTON: "open-modal-button",
};

export const NON_STANDARD_ITEM_FIELD_SELECTORS = {
    MANUFACTURER: "non-standard-manufacturer",
    SKU: "non-standard-sku",
    LINK: "non-standard-link",
    DESCRIPTION: "non-standard-description",
};
